pricing:
  tierNames:
    community: Community
    enterprise: Enterprise
companies:
  microsoft: Microsoft Corporation
  google: Google LLC
  atlassian: Atlassian Corporation
address:
  company: Ruler GmbH
  street: Seestrasse 4
  city: 3700 Spiez
  vatId: CHE-186.532.610
hardwarePricing:
  models:
    quality: Kimi K2.6 (INT4)
    hybrid: DeepSeek V4 Pro (INT4)
    speed: Qwen3-235B-A22B (INT4)
    rack: Qwen3-235B-A22B (INT4)
  modes:
    node: Single node
    multinode: Multi node
    rack: Server rack
  versions:
    nodeQuality: 26.04 (NQ)
    nodeApplication: 26.04 (NA)
    nodeSpeed: 26.04 (NS)
    multinodeQuality: 26.04 (MQ)
    multinodeHybrid: 26.04 (MH)
    multinodeSpeed: 26.04 (MS)
    rack: 26.04 (SR)
  productNumbers:
    quality: P0005
    hybrid: P0006
    speed: P0007
    rack: P0012
  tierNames:
    multinode:
      quality: Quality multi node
      hybrid: Hybrid multi node
      speed: Speed multi node
    node:
      quality: Quality node
      hybrid: Application node
      speed: Speed node
    rack:
      rack: AI server rack
  specs:
    types:
      uma: UMA
      vram: GDDR7
      ddr5: DDR5
      ddr5_ecc: DDR5 ECC
      m2_nvme: m.2 NVMe
      apple_silicon: Apple Silicon
      nvidia_rtx_pro_6000: NVIDIA RTX PRO 6000
      amd_epyc_4545p_zen5: AMD EPYC 4545P (Zen 5)
      amd_epyc_9355p_zen4: AMD EPYC 9355P (Zen 4)
    line:
      ram: '{gb}GB ({type})'
      chip: '{count}× {name}'
      ssd: '{tb}TB ({type})'
    sizes:
      node:
        quality: 197mm × 197mm × 95mm
        hybrid: 192mm × 366mm × 270mm
        speed: 192mm × 366mm × 270mm
      multinode:
        quality: 500mm × 500mm × 1500mm
        hybrid: 500mm × 500mm × 1500mm
        speed: 1500mm × 500mm × 500mm
      rack: 600mm × 1100mm × 2000mm
